import React from 'react';

import { BatchActionStatusToast, Failure, useBatchActionStatusTranslation } from '@bringg-frontend/batch-action-status';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { AsyncOperationStore } from '@bringg-frontend/global-stores';
import classNames from 'classnames';

import style from './tasks-async-operation-status.module.scss';

const TasksAsyncOperationStatus = ({ store }: { store: AsyncOperationStore<Failure<boolean>> }) => {
	const { id, displayName, totalNumberOfTasks, successfulItemsCount, failures, hideFailureReasonColumn, isExpanded } =
		store;
	const translations = useBatchActionStatusTranslation(displayName);

	return (
		<BatchActionStatusToast
			key={id}
			id={id}
			className={classNames({ [style.expandedNotification]: isExpanded })}
			translations={translations}
			// we treat the totalNumberOfActions as the total number of tasks as action in workflow is implementation detail
			totalNumberOfActions={totalNumberOfTasks}
			failures={failures}
			hideFailureReasonColumn={hideFailureReasonColumn}
			onClose={() => store.dispose()}
			currentNumberOfActionsSucceeded={successfulItemsCount}
			failureRenderer={failure => <Link to={`/history/${failure.id}`}>{failure.title}</Link>}
		/>
	);
};

export default observer(TasksAsyncOperationStatus);
